import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducer from './user/user.slice';
import infoReducer from './student/info/info.slice';
import progressReducer from './student/progress/progress.slice';
import materialReducer from './student/material/material.slice';
import homeworkReducer from './student/homework/homework.slice';
import timetableReducer from './student/timetable/timetable.slice';
import paymentReducer from './student/payment/payment.slice';
import sidebarWidthReducer from './sidebarWidth/sidebarWidth.slice';
import errorReducer from './error/error.slice';
import {
    adminHomeWorkSlice,
    adminMaterialReducer,
    adminSubjectSlice,
} from './admin';
import branchReducer from './selected-branch'
import { baseApi } from '../api';

const rootReducer = combineReducers({
    userReducer,
    infoReducer,
    progressReducer,
    materialReducer,
    homeworkReducer,
    timetableReducer,
    paymentReducer,
    adminMaterialReducer,
    adminSubjectSlice,
    adminHomeWorkSlice,
    branchReducer,
    sidebarWidthReducer,
    errorReducer,
    [baseApi.reducerPath]: baseApi.reducer,
});

export const setupStore = () => {
    return configureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware({ serializableCheck: false }).concat(
                baseApi.middleware
            ),
    });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
